<template>
  <div class="home">
    <navbar :is-active="2"></navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <div class="nav-mob-resp">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>{{company_name}}</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/Client/cp-productos" class="tab active">
            <div class="tab__icon">
              <i class="fab fa-product-hunt"></i>
            </div>
            <div class="tab__text" >
              <p>Productos</p>
            </div>
          </router-link>
          <router-link to="/Client/cp-clientes" class="tab">
            <div class="tab__icon">
              <i class="fas fa-user-friends"></i>
            </div>
            <div class="tab__text">
              <p>Clientes</p>
            </div>
          </router-link>
          <router-link to="/Client/cp-boletas" class="tab">
            <div class="tab__icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </div>
            <div class="tab__text">
              <p>Boletas</p>
            </div>
          </router-link>
        </div>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title ">
          <open-arrow></open-arrow>
          <h2 style="margin-bottom: 2rem;">Productos</h2>
        </div>
        <div>
        </div>

        <div class="page__filters">
          <div style="display: flex; flex-direction:column; margin-top: -2rem;">

          <label style="">Fecha de proceso</label>
          <input
            @change="search"
            v-model="process_start"
            type="datetime-local"
            placeholder="Fecha desde"
          />
          </div>

            <input
              @change="search"
              v-model="process_end"
              style="width: 13.5%"
              type="datetime-local"
              placeholder="Fecha hasta"
              class="mob"
            />
          <div style="display: flex; flex-direction:column; margin-top: -2rem;">
            <label style="">Fecha de compra</label>
            <input
              @change="search"
              v-model="purchase_start"
              type="datetime-local"
              placeholder="Fecha desde"
            />
          </div>
          <input
            @change="search"
            v-model="purchase_end"
            style="width: 13.5%"
            type="datetime-local"
            placeholder="Fecha hasta"
            class="mob"

          />
          <div style="display: flex; flex-direction:column; margin-top: -2rem;">
          <label>Fecha de validación</label>
          <input
            @changue="search"
            v-model="validate_start"
            type="datetime-local"
            placeholder="Fecha desde"
          />
          </div>
          <input
            @change="search"
            v-model="validate_end"
            style="width: 13.5%"
            type="datetime-local"
            placeholder="Fecha hasta"
            class="mob"
          />
          <input
            v-model="product_code"
            @change="search"
            type="text"
            placeholder="Código de producto"
          />
          <input
            v-model="branch_code"
            @change="search"
            type="text"
            placeholder="Código de sucursal"
          />
          <input
            @change="search"
            v-model="code_invoice"
            type="text"
            placeholder="Código boleta quickshop"
          />
          <input
            @change="search"
            v-model="user_code"
            type="text"
            placeholder="Código boleta cliente"
          />
          <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>

        </div>
        <div class="page__buttons">
          <button class="button" @click="conciliacion_masiva">Conciliación masiva</button>
          <ButtonExport
            :data="products_export"
            :columns="columns"
            icon="fas fa-download"
            :sheet-name="'Datos Productos'"
            :file-name="'Reporte Productos'"
          />
        </div>
        <div class="page__table" style="height: 100%; overflow: auto">
          <div class="table-headers">
            <p v-for="{ label } of columns" :key="label">{{ label }}</p>
            <p>Accion</p>
          </div>
          <div class="table-body">
            <div class="data" v-for="product of products" :key="product.id">
              <p @click="showProduct(product.id)">
                {{ codeFormat(product.product_code) }}
              </p>
              <p>{{ product.product_name }}</p>
              <p>{{ product.name }}</p>
              <p>{{ product.brand }}</p>
              <p>{{ product.invoice_det_product_amount }}</p>
              <p>{{ product.product_price }}</p>
              <p>{{ product.total }}</p>
              <p>{{ product.branch_code }}</p>
              <p>{{ product.branch_name }}</p>
              <p>{{ product.branch_nickname }}</p>
              <p>{{ codeFormat(product.code_invoice) }}</p>
              <p>{{ (product.invoice_process_date ? product.invoice_process_date : '-')}}</p>
              <p>{{ product.invoice_date_purchase}}</p>
              <p>{{ codeFormat(product.code) }}</p>
              <p>{{ (product.invoice_date_validation) }}</p>
              <p>{{ product.estado }}</p>
              <!-- <p><Dropdown :id="product.id" :type="this.type"/></p> -->
              <div class="dropdown" >
                  <button class="button" @click="show('id-dropdown-content'+product.id)">
                  <i class="fa fa-ellipsis" style="color: red"></i>
                  </button>
                <div @mouseleave="show('id-dropdown-content'+product.id)"  class="dropdown-content" :id="'id-dropdown-content'+product.id">
                  <button class="dropdown-item" @click="showAlert(product.id)" v-if="product.invoice_det_conciliation === 0">
                    <i class="fas fa-bars " ></i> Conciliar
                  </button>
                  <router-link :to="{ path: '/ClienteConciliaDetalleCliente', query: { id: product.usuario_id }}" class="dropdown-item">
                    <i class="far fa-eye " ></i> Buscar cliente
                  </router-link>  
                    <a id="link" :href="descargarBoleta+product.code_invoice"  style="padding: 0px;">
                      <div class="dropdown-item" >
                        <i class="fas fa-bars " ></i> Descargar boleta
                      </div>
                    </a>
                    <div class="dropdown-item-special">
                        Activado
                        <input
                            :id="'check_'+product.id"
                            type="checkbox"
                            :checked="(product.product_status === 1)"
                            class="dropdown-checkbox"
                           
                        />
                        <label class="wrapper" :for="'check_'+product.id">
                          <span class="circle"></span>
                        </label>
                      </div>
              </div>
            </div>
            </div>  
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Navbar from '@/components/NavBar.vue'
  import { codeFormat } from '@/utils/formats'
  import { dateFormat } from '@/utils/formats'
  import Dropdown from '@/components/Dropdown.vue'
  import ButtonExport from '@/components/ButtonExport.vue'
  import Pagination from '@/components/Pagination.vue'
  import OpenArrow from '@/components/OpenArrow.vue'
  import HiddenArrow from '@/components/HiddenArrow.vue'
  import $ from 'jquery'

  export default {
    name: 'Productos',
    components: {
      Navbar,
      ButtonExport,
      Dropdown,
      Pagination,
      OpenArrow,
      HiddenArrow
    },
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        type: 'conciliacion',
        products_count: [],
        branch_code: '',
        validate_start: '',
        validate_end: '',
        process_start: '',
        process_end: '',
        purchase_start: '',
        purchase_end: '',
        product_code: '',
        invoice_company_id: '',
        code_invoice: '',
        user_code: '',
        invoice_det_conciliation_date: '',
        invoice_date_validation: '',
        invoice_date_purchase: '',
        products: [],
        products_export:[],
        pagination: [],
        idDropdown: 'id-dropdown-content',
        timeout: null,
        descargarBoleta: axios.defaults.baseURL + 'general/download/invoice/',
        columns: [
          {
            label: 'Código de producto',
            field: 'product_code',
            dataFormat: this.codeFormat
          },
          { label: 'Nombre de producto', field: 'product_name' },
          { label: 'Tipo de Producto', field: 'name' },
          { label: 'Marca', field: 'brand' },
          { label: 'Cantidad', field: 'invoice_det_product_amount' },
          { label: 'Precio', field: 'product_price' },
          { label: 'Precio Total', field: 'total' },
          {
            label: 'Código sucursal',
            field: 'branch_code',
          },
          {
            label: 'Nombre sucursal',
            field: 'branch_name',
          },
          {
            label: 'Alias',
            field: 'branch_nickname',
          },
          {
            label: 'Código boleta quickshop',
            field: 'code_invoice',
          },
          {
            label: 'Fecha de proceso',
            field: '',
          },
          {
            label: 'Fecha de compra',
            field: 'invoice_date_purchase',
          },
          {
            label: 'Código cliente',
            field: 'user_code',
          },
          {
            label: 'Fecha de validación',
            field: 'invoice_date_validation',
          },
          {
            label: 'Estado',
            field: 'estado',
          }
        ]
      }
    },
    methods: {
      // async descargarBoleta(id){
      //   await axios.get("general/download/invoice/"+id).then((response) => {
      //   })
      //   this.descargarBoleta= axios.defaults.baseURL + 'general/download/invoice/' +id
      // },
      async showAlert(id){
        const { value: confirmButtonText } = await this.$swal.fire({
          title: 'Conciliar',
          icon: 'warning',
          text: 'Está por conciliar este item, ¿Desea confirmar la acción?',
          confirmButtonText: 'Conciliar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          showCloseButton: true
        })
        if (confirmButtonText === true){
          axios.put("general/ /unit/" + id)
          await this.$swal.fire({
            title: 'Conciliación realizada',
            icon: 'success',
            showCloseButton: true
          })
          this.getall()
        }
      },
      async conciliacion_masiva(e){
        console.log(e);
        if(Object.keys(this.products).length === 0 || this.products_count === 0){
            this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'No hay datos a conciliar'
          })
        }else{
        const { value: confirmButtonText } = await this.$swal.fire({
          title: 'Conciliar',
          icon: 'warning',
          text: 'Está por conciliar todos los items, ¿Desea confirmar la acción?',
          confirmButtonText: 'Conciliar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          showCloseButton: true
        })
        if (confirmButtonText === true){

          const json = {
            "company_id": localStorage.getItem('company_id')
          }
            axios.put("general/conciliation/massive", json)
            await this.$swal.fire({
            title: 'Conciliación realizada',
            text: `Se ${this.products_count === 1 ? 'concilió' : 'conciliaron' } ${this.products_count} ${this.products_count === 1 ? 'producto' : 'productos' }`,
            icon: 'success',
            showCloseButton: true
          })
          }
          this.getall()
        }
      },
      show(divID){
        if (!$("body").hasClass("cerrarModal")){
          $('#'+divID).fadeIn();
          setTimeout(function () {
            $("body").addClass("cerrarModal");
          }, 10);
        }
      },
      dateFormat,
      handleClickInParent: function(page) {
        this.getall(page)
      },
      clean_filter(){
        this.validate_start = '',
        this.validate_end = '',
        this.process_start = '',
        this.process_end = '',
        this.purchase_start = '',
        this.purchase_end = '', 
        this.user_code = '',
        this.code_invoice = '',
        this.product_code = '',
        this.branch_code = '',
        this.getall()
      },
      search: function() {
        clearTimeout(this.timeout);
        var self = this;
        this.timeout = setTimeout(function () {
          console.log(self)
          let paramSearch = {
            validate_start: self.validate_start,
            validate_end: self.validate_end,
            purchase_start: self.purchase_start,
            purchase_end: self.purchase_end,
            process_start: self.process_start,
            process_end: self.process_end,
            branch_code: self.branch_code,
            product_code: self.product_code,
            code_invoice: self.code_invoice,
            user_code: self.user_code,
          }
          this.getall(1, paramSearch)
        }.bind(this), 500);
      },
      codeFormat,
      
      async getall(page = 1, paramSearch = {}) {
        await axios.get('general/conciliation', {params: {
          page: page,
          invoice_company_id:  localStorage.getItem('company_id'),
          validate_start: (paramSearch.validate_start) ? paramSearch.validate_start : null,
          validate_end: (paramSearch.validate_end) ? paramSearch.validate_end : null,
          purchase_start: (paramSearch.purchase_start) ? paramSearch.purchase_start : null,
          purchase_end: (paramSearch.purchase_end) ? paramSearch.purchase_end : null,
          process_start: (paramSearch.process_start) ? paramSearch.process_start : null,
          process_end: (paramSearch.process_end) ? paramSearch.process_end : null,
          branch_code: (paramSearch.branch_code) ? paramSearch.branch_code : 0,
          product_code: (paramSearch.product_code) ? paramSearch.product_code : 0,
          code_invoice: (paramSearch.code_invoice) ? paramSearch.code_invoice : 0,
          user_code: (paramSearch.user_code) ? paramSearch.user_code : 0,
        }}).then( res => {
          console.log(res)
          if(res.data.data.total){
            console.log('############')
            console.log(res.data.data.data)
            console.log(res.data.data)
            console.log(res.data)
            console.log('############')
            this.products = res.data.data.data
            this.products_export = res.data.export
            this.products_count = res.data.count
            this.pagination = res.data.data
            this.empty = false
          }else{
            this.products = {}
            this.pagination = {}
            this.empty = true
          }
        })
      },
      goBack() {
        this.$router.back();
      },
    },  

    mounted() {
      if (localStorage.getItem('token')) {
        this.getall()
        this.company_name = localStorage.getItem('company_name');
      } else {
        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped>
  .home {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Readex Pro', sans-serif;
  }

  .body {
    width: 100%;
    height: 600px;
    display: flex;
  }

  .body__containt {
    height: calc(100vh - 120px);
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }
  .body__sidebar {
    width: 400px;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .body__sidebar .floating-icon {
    position: absolute;
    right: -15px;
    top: 30px;
    color: #ff3128;
    font-size: 30px;
  }

  .body__sidebar .title {
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .body__sidebar .title__icon {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
  }
  .body__sidebar .title__text h2 {
    font-size: 20px;
    margin: 0;
  }
  .body__sidebar .title__text p {
    margin: 0;
    font-weight: 300;
  }
  .body__sidebar .tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 140px);
    padding-top: 5px;
  }

  .body__sidebar .tabs .tab {
    width: 90%;
    height: 70px;
    border-radius: 10px;
    color: #707070;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: 0.3 ease;
  }
  .body__sidebar .tabs .tab:hover,
  .body__sidebar .tabs .tab.active {
    color: #ff3128;
    background: #ffeeed;
  }

  .body__sidebar .tabs .tab__icon {
    font-size: 20px;
    margin-right: 10px;
  }

  .body__sidebar .tabs .tab__text p {
    margin: 0;
    font-weight: 600;
  }

  .body__containt {
    min-height: 87vh;
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
  }

  .body__containt .page__title {
    width: 100%;
    margin-bottom: 20px;
  }

  .body__containt .page__title h2 {
    font-weight: 600;
    color: #ff3128;
    font-size: 25px;
  }

  .body__containt .page__filters {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
  }
  .body__containt .page__filters input,
  select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /* margin: 0 10px; */
  }

  .body__containt .page__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding-top: 2%;
  }

  .body__containt .page__buttons .button {
    width: 250px;
    padding: 15px 20px;
    border-radius: 15px;
    font-size: 17px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .body__containt .page__buttons .button:nth-child(1) {
    background: #ff3128;
  }
  .body__containt .page__buttons .button:nth-child(2) {
    background: #262626;
  }

  .body__containt .page__table {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
  }

  .body__containt .page__table .table-headers {
    width: 251%;
    height: 50px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #b6b6b6;
  }
  .body__containt .page__table .table-headers p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }

  .body__containt .page__table .table-body {
    width: 251%;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #b6b6b6;
  }

  .body__containt .page__table .table-body .data {
    width: 100%;
    display: flex;
  }
  .body__containt .page__table .table-body .data p {
    width: calc(100% / 1);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    margin: 10px 0;
  }
  .body__containt .page__table .table-body .data p:nth-child(1) {
    color: #ff3128;
  }

  .dropdown {
    position: relative;
    margin: 10px 92px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 20px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 13px;
    width: 17px;
    left: 2px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #32ba7c;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
  .body__sidebar.open{
    display: none;
  }
  ::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
/* INICIO MOBILE*/
@media (max-width: 768px){
  .body__containt .page__title h2{
    font-size: 21px;
  }
  .body__containt .page__filters input{
    padding: 5px 20px;
  }
  .page__filters select{
    padding: 10px 19px;
    width: 54% !important;
  }
  .body label{
    margin-top: 2rem;
    margin-left: 18px;
    font-size: 13px;
  }
  .body p.clean_filter{
    margin-top: 7px;
    font-size: 14px;
  }
  .buttonExport{
    margin-top: -13px;
    width: 179px;
    padding: 9px 20px;
  }
  .body__containt .page__table{
    font-size: 11px;
  }
  .body__containt .page__table .table-headers{
    margin-top: 6px;
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__sidebar .title__text h2 {
    font-size: 18px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
    font-size: 16px;
  }
  .body__sidebar .title__icon{
    font-size: 16px;
    margin-left: 6px;
  }
  .body__sidebar .tabs .tab__icon svg{
    font-size: 15px;
    margin-right: 7px;}
  .body__sidebar .tabs .a{
    margin-left: -2px;
    margin-top: -1px;
  }
  .body__sidebar a svg{
    font-size: 22px;
  }
  /*BARRA LATERAL IZQUIERDA MOBILE*/
  .body__sidebar .tabs .tab__icon {
    color: white;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
    color: #ff3128;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .tabs .tab__text p {
    margin-left: -8px;
    color: white;
    font-size: 18px;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
    background: #262626;
    margin-bottom: -11px;
  }
  .body__containt .page__buttons .button{
    font-size: 13px;
    padding: 5px 20px;
    margin-top: -18px;
    width: 163px;
  }
  .body__containt .page__buttons {
    width: 105%;
  }
  .home .body .nav-mob-resp{
    position: absolute;
    background: #262626;
    height: 85vh;
    width: 25vh;
  }
  .body__sidebar .title {
    color: white;
  }
  .body__sidebar .floating-icon {
    position: absolute;
    right: -35px;
  }
  .body__sidebar .tabs .tab{
    margin-bottom: -7px;
  }

  .body__containt .page__filters .mob {
    width: 67.5% !important;
    margin-top: -12px;
  }
}
</style>
